import axios from "axios";
import Config from "../../../config/index";
import {
  GET_DISPATCH_REPORT_FAILURE,
  GET_DISPATCH_REPORT_REQUEST,
  GET_DISPATCH_REPORT_SUCCESS,
  GET_TRANSACTION_REPORT_DOWNLOAD_FAILURE,
  GET_TRANSACTION_REPORT_DOWNLOAD_REQUEST,
  GET_TRANSACTION_REPORT_DOWNLOAD_SUCCESS,
} from "./dispatchReportTypes";
let baseUrl = Config.baseUrl;

const getDispatchReportRequest = () => {
  return {
    type: GET_DISPATCH_REPORT_REQUEST,
  };
};

const getDispatchReportSuccess = (payload) => {
  return {
    type: GET_DISPATCH_REPORT_SUCCESS,
    payload: payload,
  };
};

const getDispatchReportFailure = (error) => {
  return {
    type: GET_DISPATCH_REPORT_FAILURE,
    payload: error,
  };
};

const getDispatchReport = (pageNo, rowsPerPage, search, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getDispatchReportRequest());
    let url = `${baseUrl}/reports/dispatch?download=0&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getDispatchReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getDispatchReportFailure(err.response));
      });
  };
};

const downloadDispatchReportRequest = () => {
  return {
    type: GET_TRANSACTION_REPORT_DOWNLOAD_REQUEST,
  };
};

const downloadDispatchReportSuccess = (payload) => {
  return {
    type: GET_TRANSACTION_REPORT_DOWNLOAD_SUCCESS,
    payload: payload,
  };
};

const downloadDispatchReportFailure = (error) => {
  return {
    type: GET_TRANSACTION_REPORT_DOWNLOAD_FAILURE,
    payload: error,
  };
};

const downloadDispatchReport = (
  startDate,
  endDate,
  pageNo,
  rowsPerPage,
  search,
  jwtToken
) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(downloadDispatchReportRequest());
    let url = `${baseUrl}/reports/dispatch?download=1&startDate=${endDate}&endDate=${startDate}&page_number=${
      pageNo + 1
    }&rows_per_page=${rowsPerPage}&search=${search ? search : ""}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(downloadDispatchReportSuccess(response.data));
      })
      .catch((err) => {
        dispatch(downloadDispatchReportFailure(err.response));
      });
  };
};

export { getDispatchReport, downloadDispatchReport };
